// extracted by mini-css-extract-plugin
export default {"ratingCell":"rating_cell_ratingCell__R8-YR","clearIcon":"rating_cell_clearIcon__NjDok"};